import Vue from 'vue'
import Vuex from 'vuex'
import createLogger from 'vuex/logger'

// register vueX plugin
Vue.use(Vuex)

// debug mode
const debug = process.env.NODE_ENV !== 'production'

// initial state
const state = {
    // Browser detection
    isBrowserIE: false,
    isBrowserSafari: false,

    // Mobile detection
    isMobileSize: true,
    isMobileAgent: true,

    // Global Overlay (used for mobile hotspots content)
    isGlobalOverlayEnabled: false,

    // Environment sound
    isEnvironmentSoundPlaying: false,
    isSoundSupported: false,

    // Main navigation panel
    isNavMenuOpened: false,
    isNavMenuOpenedDelay: false,

    // Hotspots content panel
    isHotspotPanelOpened: false,
    hotspot: false,
    totalHotspots: false,
    hotspotNumber: false,
    hotspotsContent: false,

    // Fullscreen video player (youtube videos)
    isFullscreenVideoOpened: false,
    isFullscreenVideoReady: false,
    youtubeVideoId: false,
    useDefaultPreloader: false
}

// mutations
const mutations = {
    SET_BROWSER_IE (state, isIE) {
        state.isBrowserIE = (typeof isIE !== 'undefined') ? isIE : true
    },
    SET_BROWSER_SAFARI (state, isSafari) {
        state.isBrowserSafari = (typeof isSafari !== 'undefined') ? isSafari : true
    },

    SET_MOBILE_SIZE (state, isMobileSize) {
        state.isMobileSize = (typeof isMobileSize !== 'undefined') ? isMobileSize : true
    },
    SET_MOBILE_AGENT (state, isMobileAgent) {
        state.isMobileAgent = (typeof isMobileAgent !== 'undefined') ? isMobileAgent : true
    },

    ENABLE_GLOBAL_OVERLAY (state) {
        state.isGlobalOverlayEnabled = true
    },
    DISABLE_GLOBAL_OVERLAY (state) {
        state.isGlobalOverlayEnabled = false
    },

    PLAY_ENV_SOUND (state) {
        state.isEnvironmentSoundPlaying = true
    },
    STOP_ENV_SOUND (state) {
        state.isEnvironmentSoundPlaying = false
    },
    SET_SOUND_SUPPORTED (state, isSupported) {
        state.isSoundSupported = (typeof isSupported !== 'undefined') ? isSupported : true
    },

    OPEN_NAV_MENU (state) {
        state.isNavMenuOpened = true
    },
    CLOSE_NAV_MENU (state) {
        state.isNavMenuOpened = false
    },
    OPEN_NAV_MENU_DELAY (state) {
        state.isNavMenuOpenedDelay = true
    },
    CLOSE_NAV_MENU_DELAY (state) {
        state.isNavMenuOpenedDelay = false
    },

    OPEN_HOTSPOT_PANEL (state, hotspot, hotspotsContent) {
        state.isHotspotPanelOpened = true
        state.hotspot = hotspot

        state.hotspotsContent = hotspotsContent
        state.hotspotNumber = hotspotsContent.findIndex(_hotspot => _hotspot.id === hotspot.id)
        state.totalHotspots = hotspotsContent.length
    },
    CLOSE_HOTSPOT_PANEL (state) {
        state.isHotspotPanelOpened = false
    },

    OPEN_FULLSCREEN_VIDEO (state, youtubeId, useDefaultPreloader) {
        state.isFullscreenVideoOpened = true
        state.youtubeVideoId = youtubeId
        state.isFullscreenVideoReady = false
        state.useDefaultPreloader = (typeof useDefaultPreloader !== 'undefined') ? useDefaultPreloader : false
    },
    SET_FULLSCREEN_VIDEO_READY (state) {
        state.isFullscreenVideoReady = true
    },
    CLOSE_FULLSCREEN_VIDEO (state) {
        state.isFullscreenVideoReady = false
        state.isFullscreenVideoOpened = false
    }
}

// vueX instance
export default new Vuex.Store({
    state,
    mutations,
    strict: debug,
    plugins: debug ? [createLogger()] : []
})



// WEBPACK FOOTER //
// ./src/vuex/store.js